import {validate as uuidValidate} from "uuid";
import {SequenceComponent} from "../components";
import {SequenceComponentHelper} from "../extensions/SequenceComponentHelper";

export const getComponents = (node, inputs, controls, outputs) => {
    let sequenceParentComponent = {input : null};
    let videoComponents = {titleControl: null, inputs : [], controls: [], output: null};
    let avatarComponents = {titleControl: null, inputs : [], controls: [], output: null};
    let textQuestionComponents = {titleControl: null, inputs : [], controls: [], outputs: []};
    let textAnswerComponents = {titleControl: null, inputs : [], controls: [], outputs: [], orderData: []};
    let textAnswerTimeLimitComponents = {controls: []};
    let voiceAnswerComponents = {titleControl: null, inputs : [], controls: [], outputs: []};
    let defaultVoiceAnswerComponents = {controls: []};
    let voiceAnswerTimeLimitComponents = {controls: []};
    let imageComponents = {titleControl: null, inputs : [], controls: [], output: null};
    let textSlideComponents = {titleControl: null, inputs : [], controls: [], output: null};
    let audioComponents = {titleControl: null, controls: []};
    let infoComponents = {titleControl: null, controls: []};

    if (inputs !== undefined) {
        inputs.forEach(input => {
            const inputKey = input.key.split('_');
            if (!uuidValidate(inputKey[0])) {
                throw new Error('input key format is not valid!');
            }
            switch(inputKey[1]) {
                case SequenceComponent.SEQUENCE_COMPONENT_KEY:
                    if (sequenceParentComponent.input) throw new Error("Sequence cannot handle multiple inputs.");
                    sequenceParentComponent.input = input;
                    break;
                default:
                    console.error(`Component '${inputKey[1]}' does not have 'Input' handling!`);
                    break;
            }
        });
    }

    if (node.data !== undefined) {
        Object.keys(node.data).forEach(key => {
            const dataKey = key.split('_');
            if (dataKey[1] === SequenceComponent.TEXT_ANSWER_CHILD_COMPONENT_KEY && dataKey[2] === SequenceComponent.TEXT_ANSWER_ORDER_KEY) {
                textAnswerComponents.orderData.push({
                    key: key,
                    order: node.data[SequenceComponentHelper.getTextAnswerOrderKey(dataKey[0])]
                });
            }
        });
    }

    if (controls !== undefined) {
        controls.forEach(control => {
            const controlKey = control.key.split('_');
            if (!uuidValidate(controlKey[0])) {
                throw new Error('control key format is not valid!');
            }
            switch(controlKey[1]) {
                case SequenceComponent.VIDEO_CHILD_COMPONENT_KEY:
                    if (controlKey[2] === SequenceComponent.NESTED_NODE_TITLE_KEY) {
                        videoComponents.titleControl = control;
                        break;
                    }
                    videoComponents.controls.push(control);
                    break;
                case SequenceComponent.AVATAR_CHILD_COMPONENT_KEY:
                    if (controlKey[2] === SequenceComponent.NESTED_NODE_TITLE_KEY) {
                        avatarComponents.titleControl = control;
                        break;
                    }
                    avatarComponents.controls.push(control);
                    break;
                case SequenceComponent.TEXT_QUESTION_CHILD_COMPONENT_KEY:
                    if (controlKey[2] === SequenceComponent.NESTED_NODE_TITLE_KEY) {
                        textQuestionComponents.titleControl = control;
                        break;
                    }
                    textQuestionComponents.controls.push(control);
                    break;
                case SequenceComponent.VOICE_ANSWER_CHILD_COMPONENT_KEY:
                    if (controlKey[2] === SequenceComponent.NESTED_NODE_TITLE_KEY) {
                        voiceAnswerComponents.titleControl = control;
                        break;
                    }
                    voiceAnswerComponents.controls.push(control);
                    break;
                case SequenceComponent.DEFAULT_VOICE_ANSWER_CHILD_COMPONENT_KEY:
                    defaultVoiceAnswerComponents.controls.push(control);
                    break;
                case SequenceComponent.VOICE_ANSWER_TIME_LIMIT_COMPONENT_KEY:
                    voiceAnswerTimeLimitComponents.controls.push(control);
                    break;
                case SequenceComponent.TEXT_ANSWER_CHILD_COMPONENT_KEY:
                    if (controlKey[2] === SequenceComponent.NESTED_NODE_TITLE_KEY) {
                        textAnswerComponents.titleControl = control;
                        break;
                    }
                    textAnswerComponents.controls.push(control);
                    break;
                case SequenceComponent.TEXT_ANSWER_TIME_LIMIT_COMPONENT_KEY:
                    textAnswerTimeLimitComponents.controls.push(control);
                    break;
                case SequenceComponent.IMAGE_CHILD_COMPONENT_KEY:
                    if (controlKey[2] === SequenceComponent.NESTED_NODE_TITLE_KEY) {
                        imageComponents.titleControl = control;
                        break;
                    }
                    imageComponents.controls.push(control);
                    break;
                case SequenceComponent.TEXT_SLIDE_CHILD_COMPONENT_KEY:
                    if (controlKey[2] === SequenceComponent.NESTED_NODE_TITLE_KEY) {
                        textSlideComponents.titleControl = control;
                        break;
                    }
                    textSlideComponents.controls.push(control);
                    break;
                case SequenceComponent.AUDIO_CHILD_COMPONENT_KEY:
                    if (controlKey[2] === SequenceComponent.NESTED_NODE_TITLE_KEY) {
                        audioComponents.titleControl = control;
                        break;
                    }
                    audioComponents.controls.push(control);
                    break;
                case SequenceComponent.INFO_CHILD_COMPONENT_KEY:
                    if (controlKey[2] === SequenceComponent.NESTED_NODE_TITLE_KEY) {
                        infoComponents.titleControl = control;
                        break;
                    }
                    infoComponents.controls.push(control);
                    break;
                default:
                    console.error(`Component '${controlKey[1]}' does not have 'Control' handling!`);
                    break;
            }
        });
    }

    if (outputs !== undefined) {
        outputs.forEach(output => {
            const outputKey = output.key.split('_');
            if (!uuidValidate(outputKey[0])) {
                throw new Error('output key format is not valid!');
            }
            switch(outputKey[1]) {
                case SequenceComponent.VIDEO_CHILD_COMPONENT_KEY:
                    if (videoComponents.output) throw new Error("Video component cannot handle multiple outputs.");
                    videoComponents.output = output;
                    break;
                case SequenceComponent.AVATAR_CHILD_COMPONENT_KEY:
                    if (avatarComponents.output) throw new Error("Avatar component cannot handle multiple outputs.");
                    avatarComponents.output = output;
                    break;
                case SequenceComponent.VOICE_ANSWER_CHILD_COMPONENT_KEY:
                    voiceAnswerComponents.outputs.push(output);
                    break;
                case SequenceComponent.TEXT_ANSWER_CHILD_COMPONENT_KEY:
                    textAnswerComponents.outputs.push(output);
                    break;
                case SequenceComponent.IMAGE_CHILD_COMPONENT_KEY:
                    if (imageComponents.output) throw new Error("Image component cannot handle multiple outputs.");
                    imageComponents.output = output;
                    break
                case SequenceComponent.TEXT_SLIDE_CHILD_COMPONENT_KEY:
                    if (textSlideComponents.output) throw new Error("Text Slide component cannot handle multiple outputs.");
                    textSlideComponents.output = output;
                    break
                default:
                    console.error(`Component '${outputKey[1]}' does not have 'Output' handling!`);
                    break;
            }
        });
    }

    return {
        sequenceParentComponent,
        videoComponents,
        avatarComponents,
        textQuestionComponents,
        textAnswerComponents,
        textAnswerTimeLimitComponents,
        voiceAnswerComponents,
        defaultVoiceAnswerComponents,
        voiceAnswerTimeLimitComponents,
        imageComponents,
        textSlideComponents,
        audioComponents,
        infoComponents
    };
}